import { render, staticRenderFns } from "./EventHeader.vue?vue&type=template&id=22121219&scoped=true"
import script from "./EventHeader.vue?vue&type=script&lang=ts"
export * from "./EventHeader.vue?vue&type=script&lang=ts"
import style0 from "./EventHeader.vue?vue&type=style&index=0&id=22121219&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22121219",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22121219')) {
      api.createRecord('22121219', component.options)
    } else {
      api.reload('22121219', component.options)
    }
    module.hot.accept("./EventHeader.vue?vue&type=template&id=22121219&scoped=true", function () {
      api.rerender('22121219', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/EventHeader.vue"
export default component.exports